import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, Response } from '@angular/http';
import 'rxjs/add/operator/map';
import { HttpService } from './http.service';
import { UtilService } from './util.service';
import { Observable, Subject } from 'rxjs';

@Injectable()
export class HcaBookingService {
  booking: any;
  bookId: number | string;

  constructor(
    private http: HttpService,
    private utilService: UtilService
  ) { }

  set bookingId(id) {
    this.bookId = id;
  }

  get bookingId() {
    return this.bookId;
  }

  set bookingDetails(data) {
    this.booking = data;
  }

  get bookingDetails() {
    return this.booking;
  }

  getLookupDataForBooking() {
    let hotelChainId = JSON.parse(localStorage.getItem('loggedInUser')).hotelChainId;
    return this.http.get(`/getLookupDataForBooking`)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  getBookingsList(data) {
    return this.http.post(`/getAllBookngsByHotelChain`, data)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  getLoyaltyBookingByBookingId(bookingId) {
    return this.http.get(`/getLoyaltyBookingByBookingId/${bookingId}`)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  saveOrEditLoyaltyBooking(data) {
    return this.http.post(`/saveOrEditLoyaltyBooking`, data)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  syncWithPms(data) {
    return this.http.post(`/syncWithPms`, data)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  getTransactionHistory(id) {
    return this.http.get(`/getLoyaltyBookingTransactionsByTransactionId/${id}`)
        .map(res => res.json())
        .catch(this.utilService.handleError);
  }

  getTransactionList(id) {
    return this.http.get(`/getLoyaltyBookingTransactionsByBookingId/${id}`)
        .map(res => res.json())
        .catch(this.utilService.handleError);
  }

  activateOrDeactivateBooking(benefitIds, status) {
    return this.http.post(`/deleteBookings/${status}`, benefitIds)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  hardDeleteStay(bookingId) {
    return this.http.post(`/adminMember/hardDeleteStay/${bookingId}`, {})
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  search(terms: Observable<string>) {
    return terms.debounceTime(400)
      .distinctUntilChanged()
      .switchMap(term => {
        if (term.length > 0) {
          return this.getBookingTransactionSearch(term);
        } else {
          return Observable.of({ error: 0, message: '', responseObj: [] })
        }
      });
  }

  getBookingTransactionSearch(term) {
    return this.http.get(`/adminMember/getRelatedTransactions?value=${term}&memberId=990498`)
      .map(res => res.json())
      .catch(() => Observable.of({ error: 0, message: '', responseObj: [] }));
  }

  getBookingDiscounts(bookingIds) {
    return this.http.post(`/calculateBookingsDiscount`, bookingIds)
      .map(res => res.json())
      .catch(() => Observable.of({ error: 0, message: '', responseObj: [] }));
  }


}



// WEBPACK FOOTER //
// ./src/app/shared/_services/hca-booking.service.ts